var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group inline-flex cursor-pointer select-none items-center gap-2",on:{"click":_vm.toggleCheckbox}},[_c('div',{class:[
      _vm.sizeClasses[_vm.size],
      _vm.isChecked ? _vm.activeClass + ' active' : '',
      _vm.customClass,
      'ring-primary group-[.invalid]:not-[.active]:text-red-500 flex items-center justify-center border border-gray-300 transition-colors focus-visible:outline-none focus-visible:ring focus-visible:ring-1 group-[.invalid]:border-red-500 dark:border-neutral-700',
    ]},[_vm._t("icon",function(){return [(_vm.isChecked)?_c('lucide-icon',{attrs:{"icon":"Check","size":_vm.iconSizes[_vm.size]}}):_c('lucide-icon',{attrs:{"icon":"X","size":_vm.iconSizes[_vm.size]}})]})],2),_c('label',{class:[
      _vm.labelSizes[_vm.size],
      'flex h-full cursor-pointer items-center gap-2 font-medium leading-none group-[.invalid]:text-red-500',
    ]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }